const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || '';

/** Resolve backend-managed media while preserving public and external URLs. */
export function resolveMediaUrl(mediaUrl: string, backendUrl = BACKEND_URL): string {
  if (
    !mediaUrl ||
    mediaUrl.startsWith('http://') ||
    mediaUrl.startsWith('https://') ||
    mediaUrl.startsWith('data:') ||
    mediaUrl.startsWith('blob:') ||
    mediaUrl.startsWith('/images/')
  ) {
    return mediaUrl;
  }

  return `${backendUrl}${mediaUrl}`;
}
